module.exports = __webpack_public_path__ + "img/ico_agendamento.af9ca9bf.svg";